import React from 'react';
import styled from 'styled-components';
import logoImage from 'static/img/logo.png';
import { Card, DynamicForm } from 'components/elements';
import { loginAction } from 'actions/auth.js';
import { connect } from 'react-redux';
import Axios from 'axios';
import { handleCatch } from '../../inc/functions';
import { Button, Input } from '../../components/elements';
import { useRef } from 'react';

const Login = ({ className, onLogin }) => {

  const usernameRef = useRef();
  const passwordRef = useRef();
  const langRef = useRef();

  const headerCmp = (
    <div className={`${className}__header`}>
      <img style={{ width: 250 }} src={logoImage} alt="Bahraman Logo" />
    </div>
  );

  //   const fields = [
  // 	{
  //       type: 'select',
  //       name: 'BASE_URL',
  //       placeholder: 'زبان',
  // 	  defaultValue: 'https://bahraman.com/fa',
  // 	  options: 
  //     },
  //     {
  //       type: 'text',
  //       name: 'username',
  //       placeholder: 'نام کاربری',
  //     },
  //     {
  //       type: 'password',
  //       name: 'password',
  //       placeholder: 'رمز عبور',
  //     },
  //   ];

  const languageOptions = [
    {
      label: 'فارسی',
      value: 'https://bahraman.com/fa'
    },
    {
      label: 'انگلیسی',
      value: 'https://bahraman.com/en'
    },
  ]

  const handleLogin = (e) => {
    e.preventDefault();

    const baseUrl = langRef.current.value;

    console.log(baseUrl);

    const data = {
      username: usernameRef.current.value,
      password: passwordRef.current.value,
    };

    if (!baseUrl || baseUrl === 'زبان') {
      alert('لطفا زبان را انتخاب کنید');
      return;
    }

    if (!data.username || !data.password) {
      alert('نام کاربری و رمز خود را وارد کنید');
      return;
    }

    
    onLogin(baseUrl, data).then((res) => {
      localStorage.setItem("BASE_URL", baseUrl);
      window.location.replace("/");
    }).catch((err) => {
      handleCatch(err);
    });
  };

  return (
    <Card className={className} header={headerCmp}>
      <form onSubmit={handleLogin}>
        <Input.Select options={languageOptions} ref={langRef} placeholder="زبان" />
        <Input placeholder="نام کاربری" ref={usernameRef} />
        <Input type="password" placeholder="رمز عبور" ref={passwordRef} />
        <Button block onClick={handleLogin}>ورود</Button>
      </form>
    </Card>
  );
};

const StyledLogin = styled(Login)`
    &__header{
    width: 100%;
    text-align: center;
    /* padding-bottom: 20px; */
    img{
      max-width: 100%;
      width: 200px;
    }
  }
`;

const mapStateToProps = state => ({
});
const mapDispatchToProps = (dispatch) => ({
  onLogin: (baseUrl, data) => dispatch(loginAction(baseUrl, data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(StyledLogin);
